const QUARTERS_PER_HOUR = 4;
const DECIMAL_HOURS_PATTERN = /^(\d+(\.\d*)?|\.\d+)$/;
const DECIMAL_HOURS_DRAFT_PATTERN = /^\d*([.,]\d*)?$/;

export const isDecimalHoursDraft = (text: string): boolean => DECIMAL_HOURS_DRAFT_PATTERN.test(text);

export const parseDecimalHours = (text: string): number | null => {
  const value = text.trim().replace(',', '.');
  if (!DECIMAL_HOURS_PATTERN.test(value)) return null;

  return Number(value);
};

export const roundToQuarterHour = (hours: number): number => Math.round(hours * QUARTERS_PER_HOUR) / QUARTERS_PER_HOUR;

export const parseRoundedDecimalHours = (text: string): number | null => {
  const hours = parseDecimalHours(text);
  return hours === null ? null : roundToQuarterHour(hours);
};

export const normalizeDecimalHours = (text: string): string => {
  const hours = parseRoundedDecimalHours(text);
  if (hours === null) return text;

  return hours.toFixed(2);
};
